import { useState } from 'react'
import { useAsyncEffect } from 'utils'
import { MediaSprite } from '../../../types'

export function useMediaThumbnail(sprite: MediaSprite | null) {
    const [state, setState] = useState<HTMLCanvasElement | null>(null)

    useAsyncEffect(async () => {
        if (!sprite) {
            setState(null)
            return
        }

        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')

        canvas.width = sprite.frameWidth
        canvas.height = sprite.frameHeight

        context?.drawImage(sprite.canvas, 0, 0)

        setState(canvas)
    }, [sprite])

    return state
}
